<!--
Booking confirmation screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Booking Confirmed" :back="false" :showNotif="true"/>
  <div class="contain">
    <main class="p-2">
      <p id="bookingSubmitHdr">Booking complete</p>
      <p id="bookingSubmitMsg">
        You will be able to see your booking in your timetable. If you wish to cancel your booking, you can do this on
        the room booking screen.
      </p>
      <img src="@/assets/circle-tick.svg" id="bookEndImg"/>
      <router-link to="/findaspace/1" class="list-group-item" id="bookingBack" tabindex="0">
        Done
      </router-link>
    </main>
    <div id="pusher"></div>
    <Footer active="booking"/>
    </div>
  </div>
</template>

<script setup>
  import {ref} from 'vue'
  import Footer from '@/components/FooterMenu.vue'

  const room = ref({})

</script>


<style scoped>
a.list-group-item {
    padding-top: 10px;
    padding-bottom: 10px;
}
#bookingBack {
  border: 1px solid #003865;
  background-color:#003865;
  color:#ffffff;
  font-weight:700;
  border-radius:12px;
  text-align:center;
}

#bookingSubmitHdr {
  margin-left: 20px;
  margin-top:20px;
  font-weight: 700;
  font-size: 20px;
  text-align:left;
  color:#005C8A;
}

#bookingSubmitMsg {
  margin-left: 20px;
  margin-right: 20px;
  text-align:left;
  font-weight: 400;
  font-size: 18px;
  color:#005C8A;
}

#bookEndImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:30px;
  margin-bottom:90px;
}
</style>
